import React, { Component } from "react";

import "../App.css";
import "../css/style.css";
import "../css/bootstrap.css";
import logo from "../Assets/mathisadmission.png";

class Table19 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      random: Math.floor(Math.random() * 20) + 1,
      number: 19,
      answer: "",
      min: 1,
      max: 20,
      question: 1,
      result: 0,
      message: "C'est parti!",
      messageColor: "black-message",
    };
  }

  mySubmitHandlerOperation = (event) => {
    event.preventDefault();
    var good = this.state.random * this.state.number;
    if (Number(this.state.answer) === good) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.random +
          " x " +
          this.state.number +
          " = " +
          good,
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.random +
          " x " +
          this.state.number +
          " = " +
          good,
      });
    }
    var rand =
      Math.floor(
        Math.random() * (Number(this.state.max) - Number(this.state.min) + 1)
      ) + Number(this.state.min);
    var que = Math.floor(Math.random() * 2) + 1;
    var res = rand * this.state.number;
    this.setState({ random: rand, question: que, result: res, answer: "" });
  };

  mySubmitHandlerResultat = (event) => {
    event.preventDefault();
    var good = this.state.random;
    if (Number(this.state.answer) === good) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.result +
          " = " +
          this.state.number +
          " x " +
          good,
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.result +
          " = " +
          this.state.number +
          " x " +
          good,
      });
    }
    var rand =
      Math.floor(
        Math.random() * (Number(this.state.max) - Number(this.state.min) + 1)
      ) + Number(this.state.min);
    var que = Math.floor(Math.random() * 2) + 1;
    var res = rand * this.state.number;
    this.setState({ random: rand, question: que, result: res, answer: "" });
  };

  myChangeHandler = (event) => {
    this.setState({ answer: event.target.value });
  };

  myChangeMin = (event) => {
    this.setState({ min: event.target.value });
  };
  myChangeMax = (event) => {
    this.setState({ max: event.target.value });
  };

  // componentDidMount() {
  //
  // }

  render() {
    // Si question == 1 alors le cube sera posé
    if (this.state.question === 1) {
      return (
        <div className="App">
          <div className="navigation">
            <img
              className="website-logo"
              src={logo}
              alt="Logo Mathis Admission"
            />
            <h1 className="website-title-text">Prepa Tage Mage</h1>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col">
              <h2 className="menu-principal-text">Table 19</h2>
            </div>
          </div>

          <div className="container">
            <p>
              Par défaut la table posée sera entre 1 et 20, mais vous pouvez
              changer le min et/ou le maximum :{" "}
            </p>
            <form
              className="col"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onSubmit={this.mySubmitHandlerOperation}
            >
              <div className="row" style={{ alignItems: "baseline" }}>
                <p style={{ marginRight: 10 }}>Min</p>
                <input
                  className="input-min"
                  type="number"
                  name="min"
                  onChange={this.myChangeMin}
                />
                <p style={{ marginRight: 10 }}>Max</p>
                <input
                  className="input-max"
                  type="number"
                  name="max"
                  onChange={this.myChangeMax}
                />
              </div>
              <p>Minimum actuel: {this.state.min}</p>
              <p>Maximum actuel: {this.state.max}</p>
              <p
                className={this.state.messageColor}
                style={{ marginTop: 40, marginBottom: 20 }}
              >
                {this.state.message}
              </p>
              <div className="row">
                <label className="label-exos">
                  {this.state.random} x {this.state.number} = ?
                </label>
              </div>
              <input
                className="input-square"
                type="number"
                name="answer"
                value={this.state.answer} 
                onChange={this.myChangeHandler}
              />
              <input
                className="validate-button"
                style={{ backgroundColor: "#00cfa4" }}
                type="submit"
                value="Valider"
              />
            </form>
            <p>Besoin d'un peu d'aide ? Scroll la page pour voir le cours ;)</p>

          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col-12 col-lg-4">
              <a className="all-button" href="/">
                Retour au menu
              </a>
            </div>
          </div>

          <div class="rappel">
            <h3>Rappel de cours :</h3>
            <div>
              {Array.from({ length: 20 }, (_, i) => (
                 <p key={i}> 19 × {i + 1} = {19 * (i + 1)} </p>
              ))}
            </div>
          </div>

        </div>
      );
    } else {
      return (
        <div className="App">
          <div className="navigation">
            <img
              className="website-logo"
              src={logo}
              alt="Logo Mathis Admission"
            />
            <h1 className="website-title-text">Prepa Tage Mage</h1>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col">
              <h2 className="menu-principal-text">Table 19</h2>
            </div>
          </div>

          <div className="container">
            <p>
              Par défaut la table posée sera entre 1 et 20, mais vous pouvez
              changer le min et/ou le maximum :{" "}
            </p>
            <form
              className="col"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onSubmit={this.mySubmitHandlerResultat}
            >
              <div className="row" style={{ alignItems: "baseline" }}>
                <p style={{ marginRight: 10 }}>Min</p>
                <input
                  className="input-min"
                  type="number"
                  name="min"
                  onChange={this.myChangeMin}
                />
                <p style={{ marginRight: 10 }}>Max</p>
                <input
                  className="input-max"
                  type="number"
                  name="max"
                  onChange={this.myChangeMax}
                />
              </div>
              <p>Minimum actuel: {this.state.min}</p>
              <p>Maximum actuel: {this.state.max}</p>
              <p
                className={this.state.messageColor}
                style={{ marginTop: 40, marginBottom: 20 }}
              >
                {this.state.message}
              </p>
              <div className="row">
                <label className="label-exos">
                  {this.state.result} = {this.state.number} x ?
                </label>
              </div>
              <input
                className="input-square"
                type="number"
                name="answer"
                value={this.state.answer} 
                onChange={this.myChangeHandler}
              />
              <input
                className="validate-button"
                style={{ backgroundColor: "#00cfa4" }}
                type="submit"
                value="Valider"
              />
            </form>
            <p>Besoin d'un peu d'aide ? Scroll la page pour voir le cours ;)</p>

          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col-12 col-lg-4">
              <a className="all-button" href="/">
                Retour au menu
              </a>
            </div>
          </div>

          <div class="rappel">
            <h3>Rappel de cours :</h3>
            <div>
              {Array.from({ length: 20 }, (_, i) => (
                 <p key={i}> 19 × {i + 1} = {19 * (i + 1)} </p>
              ))}
            </div>
          </div>
          
        </div>
      );
    }
  }
}

export default Table19;
